var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5H6C4.895 5 4 5.895 4 7V17C4 18.105 4.895 19 6 19H8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.431 20.952L18.431 19.848C19.348 19.646 20 18.833 20 17.895V6.10497C20 5.16697 19.348 4.35397 18.431 4.15197L13.431 3.04797C12.183 2.77197 11 3.72197 11 5.00097V19C11 20.278 12.183 21.228 13.431 20.952V20.952Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11V13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/LogIn.8e6a88ec74d98abf15f59c28c89e48f3.svg";
export { ForwardRef as ReactComponent };